import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Redirect } from 'react-router-dom';

import { DataHandler, StorageHandler } from 'C4';
import { storageKeys } from 'settings';


const updateQuery = (value) => {
  StorageHandler.save(storageKeys.lastSearchQuery, value);
};

export default class NavSearch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false,
      submitted: false,
    };

    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleExpand = this.handleExpand.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  handleExpand() {
    this.setState({ expanded: true });
  }

  handleFormSubmit(e) {
    e.preventDefault();
    updateQuery(e.target.querySelector('#search').value);
    this.setState({ submitted: true });
  }

  handleClickOutside() {
    this.setState({ expanded: false });
  }

  render() {
    const { submitted } = this.state;
    return (
      <form className="searchContainer" onSubmit={e => this.handleFormSubmit(e)}>
        <label className="search" htmlFor="search">
          <button>
            <FontAwesomeIcon icon={['fas', 'search']} />
          </button>
          <input
            id="search"
            className={`searchInput ${this.state.expanded && 'expanded'}`}
            name="search"
            type="text"
            autoComplete="off"
            placeholder={this.props.placeholder}
            onClick={this.handleExpand}
            onBlur={this.handleClickOutside}
          />
        </label>
        {submitted && <Redirect to="/main/search" />}
      </form>
    );
  }
}

NavSearch.propTypes = {
  placeholder: PropTypes.string,
};

NavSearch.defaultProps = {
  placeholder: 'Search',
};
